module.exports = __webpack_public_path__ + "img/iq.e91e8962.png";